import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioChange, MatRadioModule } from '@angular/material/radio';
import {
  MatDateRangePicker,
  MatDatepicker,
  MatDatepickerModule,
} from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { OverlayButtonComponent } from '../overlay-button/overlay-button.component';
import { MatBadgeModule } from '@angular/material/badge';

type DateFilterValue = null | { start: Date; end: Date } | Date;

@Component({
  selector: 't-llevo-date-filter',
  standalone: true,
  imports: [
    OverlayModule,
    MatButtonModule,
    MatIconModule,
    MatRadioModule,
    MatDatepickerModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    MatInputModule,
    OverlayButtonComponent,
    MatBadgeModule,
  ],
  templateUrl: './date-filter.component.html',
  styleUrl: './date-filter.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateFilterComponent {
  @Input() disabled = false

  @Output() valueChange = new EventEmitter();

  @ViewChild('picker') datePicker: MatDatepicker<Date> | undefined;
  @ViewChild('rangePicker') rangePicker: MatDateRangePicker<Date> | undefined;

  readonly formGroup = new FormGroup({
    range: new FormGroup({
      start: new FormControl(),
      end: new FormControl(),
    }),
    date: new FormControl(),
  });

  selectedFilter = 'range';
  private _isOpen = false;
  protected maxDate = new Date()

  get range() {
    return this.formGroup.controls['range'];
  }

  get date() {
    return this.formGroup.controls['date'];
  }

  open() {
    this._isOpen = true;
  }

  close() {
    if (!this.datePicker?.opened) this._isOpen = false;
  }

  get isOpen() {
    return this._isOpen;
  }

  filterChange(event: MatRadioChange) {
    this.selectedFilter = event.value;
  }

  isDatepickerOpen() {
    if (this.rangePicker?.opened || this.datePicker?.opened) {
      return true;
    }
    return false;
  }

  get hasValueSelected() {
    if (
      this.selectedFilter == 'range' &&
      this.range.controls['start'].value &&
      this.range.controls['end'].value
    ) {
      return true;
    } else if (
      (this.selectedFilter == 'before' || this.selectedFilter == 'after') &&
      this.date.value
    ) {
      return true
    }
    return false
  }

  get value(): DateFilterValue{
    if (
      this.selectedFilter == 'range' &&
      this.range.controls['start'].value &&
      this.range.controls['end'].value
    ) {
      return this.range.getRawValue();
    } else if (
      (this.selectedFilter == 'before' || this.selectedFilter == 'after') &&
      this.date.value
    ) {
      return this.date.getRawValue()
    }
    return null
  }

  onSubmit(){
    this.valueChange.emit(this.value)
  }

  deleteSelectedValue(){
    this.range.controls['start'].setValue(null)
    this.range.controls['end'].setValue(null)
    this.date.setValue(null)

    this.valueChange.emit(null);
  }
}
